import { Layout } from "@/components/layout";
import { t } from "i18next";
import HashTabs, { type HashTab } from "../../components/ui/HashTabs";
import SubscriptionTopBar from "./components/SubscriptionTopBar";
import { useEffect, useMemo } from "react";
import { useAuthStore } from "@/store/auth.store";
import AccountSettings from "./AccountSettings";
import TranscriptionSettings from "./TranscriptionSettings";
import SubscriptionSettings from "./SubscriptionSettings";
import { ProfileSettings } from "./ProfileSettings";
import { SecuritySettings } from "./SecuritySettings";
import { PlanName } from "@/common/enums/enums";

export const Settings = (): JSX.Element => {
  const { userData, getUser, loading } = useAuthStore.getState();

  const tabs: HashTab[] = useMemo(
    () => [
      {
        label: t("settings.profile.menuItem"),
        value: "profile",
        content: <ProfileSettings />,
      },
      {
        label: t("settings.transcription.menuItem"),
        value: "transcription",
        content: <TranscriptionSettings />,
      },
      {
        label: t("settings.subscription.menuItem"),
        value: "subscription",
        content: <SubscriptionSettings />,
      },
      {
        label: t("settings.security.menuItem"),
        value: "security",
        content: <SecuritySettings />,
      },
      {
        label: t("settings.account.menuItem"),
        value: "account",
        content: <AccountSettings />,
      },
    ],
    []
  );

  useEffect(() => {
    if (userData) {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      getUser(userData.email);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout
      isLoading={loading}
      navbarTitle={t("settings.title")}
      breadcrumbs={[
        { name: t("settings.title"), href: `/settings`, current: true },
      ]}
    >
      <SubscriptionTopBar
        shouldShowExpirationDate={userData?.planName !== PlanName.FREE_TRIAL}
      />
      <div className="mx-auto max-w-5xl">
        <HashTabs tabs={tabs} />
      </div>
    </Layout>
  );
};
